import { Component, Injector, Input, OnInit, Output, EventEmitter, ViewChildren, SimpleChanges, OnChanges, AfterViewInit, OnDestroy, QueryList } from '@angular/core';
import { AppEntitiesServiceProxy, AppTransactionServiceProxy, GetAppTransactionsForViewDto, ContactRoleEnum, AppTransactionContactDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { finalize, Subscription } from 'rxjs';
import { AddressComponent } from '../../address/address.component';
import * as moment from 'moment';
import { TransactionCartoccordionTabs } from '../../../../enums/TransactionCartoccordionTabs';

@Component({
  selector: 'app-create-or-edit-billing-info',
  templateUrl: './create-or-edit-billing-info.component.html',
  styleUrls: ['./create-or-edit-billing-info.component.scss']
})
export class CreateOrEditBillingInfoComponent extends AppComponentBase implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input("activeTab") activeTab: number;
  @Input("currentTab") currentTab: number;
  @Input("appTransactionsForViewDto") appTransactionsForViewDto: GetAppTransactionsForViewDto;
  @Input("createOrEditBillingInfo") createOrEditBillingInfo: boolean = true;
  @Input("canChange") canChange: boolean = true;
  @Input("showSaveBtn") showSaveBtn: boolean = false;

  @Output("generatOrderReport") generatOrderReport: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output("BillingInfoValid") BillingInfoValid: EventEmitter<TransactionCartoccordionTabs> = new EventEmitter<TransactionCartoccordionTabs>();
  @Output("refreshShoppingCart") refreshShoppingCart: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output("ontabChange") ontabChange: EventEmitter<TransactionCartoccordionTabs> = new EventEmitter<TransactionCartoccordionTabs>()

  @ViewChildren(AddressComponent) addressComponentRefs: QueryList<AddressComponent>;

  isContactsValid: boolean = true;
  transactionCartoccordionTabs = TransactionCartoccordionTabs;
  contactIdARContact: string = '';
  contactIdApContact: string = '';
  addressSelected: boolean = false;
  payTermsListList: any = [];
  isArContactsValid: boolean = false;
  enableSAveApcontact: boolean = false;
  oldappTransactionsForViewDto: any;
  isApContactsValid: boolean = false;
  enableSAveArcontact: boolean = false;
  apContactSelectedAdd: any;
  arContactSelectedAdd: any
  cancelBtn: boolean = false;
  saveBtn: boolean = false;
  isAccManual: boolean = false
  apContactdata;
  arContactdata;

  subscriptions: Subscription[] = [];
  constructor(
    injector: Injector,
    private _AppTransactionServiceProxy: AppTransactionServiceProxy,
    private _appEntitiesServiceProxy: AppEntitiesServiceProxy,
  ) {
    super(injector);

  }

  ngAfterViewInit() {
    if (this.currentTab == TransactionCartoccordionTabs.BillingInfo) {
      this.contactIdApContact = this.apContactdata?.compId;
      this.contactIdARContact = this.arContactdata?.compId;
      const addressComponents = this.addressComponentRefs.toArray();
      addressComponents.find(c => c.billingIndexInfo === 1)?.getAddressList(this.apContactdata?.compssin,  this.apContactdata?.branchSsin);
      addressComponents.find(c => c.billingIndexInfo === 2)?.getAddressList(this.arContactdata?.compssin,  this.arContactdata?.branchSsin);
    }

  }
  ngOnInit() {
    this.isMamualAcc()
    if (this.currentTab == TransactionCartoccordionTabs.BillingInfo) {
      this.oldappTransactionsForViewDto = JSON.parse(JSON.stringify(this.appTransactionsForViewDto));
      let apContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.APContact);
      apContactObj[0]?.companySSIN && apContactObj[0]?.contactAddressDetail?.addressLine1 ? this.apContactSelectedAdd = apContactObj[0]?.contactAddressDetail : null;
      let arContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.ARContact);
      arContactObj[0]?.companySSIN && arContactObj[0]?.contactAddressDetail?.addressLine1 ? this.arContactSelectedAdd = arContactObj[0]?.contactAddressDetail : null;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.currentTab == TransactionCartoccordionTabs.BillingInfo) {
      if (this.appTransactionsForViewDto) {
        this.oldappTransactionsForViewDto = JSON.parse(JSON.stringify(this.appTransactionsForViewDto));
        let apContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.APContact);
        apContactObj[0]?.companySSIN && apContactObj[0]?.contactAddressDetail?.addressLine1 ? this.apContactSelectedAdd = apContactObj[0]?.contactAddressDetail : null;
        let arContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.ARContact);
        arContactObj[0]?.companySSIN && arContactObj[0]?.contactAddressDetail?.addressLine1 ? this.arContactSelectedAdd = arContactObj[0]?.contactAddressDetail : null;
        this.loadpayTermsListListist();
      }
    }
  }
  isMamualAcc() {
    let accSSin = ''
    if (this.appTransactionsForViewDto?.entityObjectTypeCode == 'SALESORDER') {
      accSSin = this.appTransactionsForViewDto?.buyerCompanySSIN
    } else if (this.appTransactionsForViewDto?.entityObjectTypeCode == 'PURCHASEORDER') {
      accSSin = this.appTransactionsForViewDto?.sellerCompanySSIN
    }
    const subs = this._AppTransactionServiceProxy.isManualCompany(accSSin)
      .subscribe((res) => {

        this.isAccManual = res;

      })
    this.subscriptions.push(subs)
  }
  updateTabInfo(addObj, contactRole) {
    let contactIndex = this.appTransactionsForViewDto?.appTransactionContacts?.findIndex(x => x.contactRole == contactRole);
    if (contactIndex < 0 || contactIndex == this.appTransactionsForViewDto?.appTransactionContacts?.length) {
      var appTransactionContactDto: AppTransactionContactDto = new AppTransactionContactDto();
      appTransactionContactDto.contactRole = contactRole;
      appTransactionContactDto.contactAddressCode = addObj.code;
      appTransactionContactDto.contactAddressId = addObj.id;
      appTransactionContactDto.contactAddressTypyId = addObj.typeId;

      this.appTransactionsForViewDto?.appTransactionContacts.push(appTransactionContactDto);
    } else {


      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactRole = contactRole;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressCode = addObj.code;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressId = addObj.id;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressTypyId = addObj.typeId;

      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressLine1 = addObj?.selectedAddressObj?.addressLine1;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressLine2 = addObj?.selectedAddressObj?.addressLine2;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressName = addObj?.selectedAddressObj?.name;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressPostalCode = addObj?.selectedAddressObj?.postalCode;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressState = addObj?.selectedAddressObj?.state;
      this.appTransactionsForViewDto.appTransactionContacts[contactIndex].contactAddressDetail = addObj?.selectedAddressObj;


    }
    if (this.isContactsValid) {
      let apContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.APContact);
      let arContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.ARContact);
      apContactObj[0]?.contactAddressDetail && apContactObj[0]?.contactAddressDetail?.addressLine1 ? this.enableSAveApcontact = true : apContactObj[0]?.contactAddressId ? this.enableSAveApcontact = true : this.enableSAveApcontact = false;
      arContactObj[0]?.contactAddressDetail && arContactObj[0]?.contactAddressDetail?.addressLine1 ? this.enableSAveArcontact = true : arContactObj[0]?.contactAddressId ? this.enableSAveArcontact = true : this.enableSAveArcontact = false;

      if (this.enableSAveArcontact && this.enableSAveApcontact && this.appTransactionsForViewDto.paymentTermsId) {
        this.BillingInfoValid.emit(TransactionCartoccordionTabs.BillingInfo);

      }
    }



    if (contactRole == ContactRoleEnum.APContact) {
      this.apContactSelectedAdd = addObj.selectedAddressObj
    } else {
      this.arContactSelectedAdd = addObj.selectedAddressObj

    }

  }

  isContactFormValid(value, sectionIndex) {
    let apContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.APContact);
    let arContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.ARContact);

    if (this.activeTab == this.transactionCartoccordionTabs.BillingInfo) {
      this.isContactsValid = value;
      if (this.isContactsValid) {
        if (sectionIndex == 1) {
          (apContactObj[0]?.contactAddressDetail && apContactObj[0]?.contactAddressDetail?.addressLine1) ? this.enableSAveApcontact = true : apContactObj[0]?.contactAddressId ? this.enableSAveApcontact = true : this.enableSAveApcontact = false;
        } else {
          (!arContactObj[0]?.companySSIN) || (arContactObj[0]?.contactAddressDetail && arContactObj[0]?.contactAddressDetail?.addressLine1) ? this.enableSAveArcontact = true : arContactObj[0]?.contactAddressId ? this.enableSAveArcontact = true : this.enableSAveArcontact = false;
        }
        this.enableSAveArcontact && this.enableSAveApcontact && this.appTransactionsForViewDto.paymentTermsId ? this.isContactsValid = true : this.isContactsValid = false;
        if (this.enableSAveArcontact && this.enableSAveApcontact && this.appTransactionsForViewDto.paymentTermsId) {
          this.isContactsValid = true;
          this.BillingInfoValid.emit(TransactionCartoccordionTabs.BillingInfo);

        } else {
          this.isContactsValid = false;
        }
      } else {
        if (sectionIndex == 1) {
          this.enableSAveApcontact = false;
        } else {
          this.enableSAveArcontact = false;
        }

      }

    }

  }
  loadpayTermsListListist() {
    const subs = this._appEntitiesServiceProxy.getAllEntitiesByTypeCode('PAYMENT-TERMS')
      .subscribe((res) => {
        this.payTermsListList = res;
        if (!this.appTransactionsForViewDto.paymentTermsId && this.payTermsListList.length == 1) {
          this.appTransactionsForViewDto.paymentTermsId = this.payTermsListList[0]?.value;
          this.appTransactionsForViewDto.paymentTermsCode = this.payTermsListList[0]?.code;

        }
      })
    this.subscriptions.push(subs)
  }
  onUpdateAppTransactionsForViewDto($event) {
    this.appTransactionsForViewDto = $event;
  }



  reloadAddresscomponentAPContact(data) {
    this.apContactdata = data;

    if (this.currentTab == TransactionCartoccordionTabs.BillingInfo) {
      this.contactIdApContact = this.apContactdata?.compId;
      const addressComponents = this.addressComponentRefs.toArray();
      addressComponents.find(c => c.billingIndexInfo === 1)?.getAddressList(this.apContactdata?.compssin, this.apContactdata?.branchSsin);
    }


  }


  reloadAddresscomponentARContact(data) {
    this.arContactdata = data;
    if (this.currentTab == TransactionCartoccordionTabs.BillingInfo) {
      this.contactIdARContact = this.arContactdata?.compId;
      const addressComponents = this.addressComponentRefs.toArray();
      addressComponents.find(c => c.billingIndexInfo === 2)?.getAddressList(this.arContactdata?.compssin,  this.arContactdata?.branchSsin);
    }


  }



  createOrEditTransaction() {
    this.showMainSpinner()
    this.saveDates()
    this.appTransactionsForViewDto.timeZoneValue = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const subs = this._AppTransactionServiceProxy.createOrEditTransaction(this.appTransactionsForViewDto)
      .pipe(finalize(() => {
        this.hideMainSpinner();
        this.refreshShoppingCart.emit(true)
      }))
      .subscribe((res) => {
        if (res) {
          this.oldappTransactionsForViewDto = JSON.parse(JSON.stringify(this.appTransactionsForViewDto));
          if (!this.showSaveBtn) {
            this.ontabChange.emit(TransactionCartoccordionTabs.BillingInfo);
          }
          else {
            this.showSaveBtn = false;

          }
        }
      });
    this.subscriptions.push(subs)
  }
  onshowSaveBtn($event) {
    this.showSaveBtn = $event;
  }
  onshowBillingEditMode($event) {
    if ($event) {
      this.createOrEditBillingInfo = true;
    }
  }
  showEditMode() {
    this.createOrEditBillingInfo = true;
    this.showSaveBtn = true;
    this.oldappTransactionsForViewDto = JSON.parse(JSON.stringify(this.appTransactionsForViewDto));
  }

  save() {
    this.createOrEditBillingInfo = false;
    this.setAddress();
    this.createOrEditTransaction();
  }
  cancel() {
    this.appTransactionsForViewDto = JSON.parse(JSON.stringify(this.oldappTransactionsForViewDto));
    this.apContactSelectedAdd = null;
    this.arContactSelectedAdd = null;
    this.setAddress();
    this.onUpdateAppTransactionsForViewDto(this.appTransactionsForViewDto);
    this.createOrEditBillingInfo = false;
    this.showSaveBtn = false;
  }
  setAddress() {
    let apContactIndx = this.appTransactionsForViewDto?.appTransactionContacts?.findIndex(x => x.contactRole == ContactRoleEnum.APContact);
    let arContactIndx = this.appTransactionsForViewDto?.appTransactionContacts?.findIndex(x => x.contactRole == ContactRoleEnum.ARContact);

    if (!this.apContactSelectedAdd) {
      let apContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.APContact);
      apContactObj[0]?.companySSIN && apContactObj[0]?.contactAddressDetail?.addressLine1 ? this.apContactSelectedAdd = apContactObj[0]?.contactAddressDetail : null;

      if (apContactIndx >= 0)
        this.appTransactionsForViewDto.appTransactionContacts[apContactIndx].contactAddressId = this.apContactSelectedAdd?.id;

    }
    else {
      if (apContactIndx >= 0) {
        this.appTransactionsForViewDto.appTransactionContacts[apContactIndx].contactAddressDetail = this.apContactSelectedAdd;
        this.appTransactionsForViewDto.appTransactionContacts[apContactIndx].contactAddressId = this.apContactSelectedAdd?.id;
      }
    }
    if (!this.arContactSelectedAdd) {
      let arContactObj = this.appTransactionsForViewDto?.appTransactionContacts?.filter(x => x.contactRole == ContactRoleEnum.ARContact);
      arContactObj[0]?.companySSIN && arContactObj[0]?.contactAddressDetail?.addressLine1 ? this.arContactSelectedAdd = arContactObj[0]?.contactAddressDetail : null;
      if (arContactIndx >= 0)
        this.appTransactionsForViewDto.appTransactionContacts[arContactIndx].contactAddressId = this.arContactSelectedAdd?.id;

    }
    else {
      if (arContactIndx >= 0) {
        this.appTransactionsForViewDto.appTransactionContacts[arContactIndx].contactAddressDetail = this.arContactSelectedAdd;
        this.appTransactionsForViewDto.appTransactionContacts[arContactIndx].contactAddressId = this.arContactSelectedAdd?.id;
      }
    }
  }

  updateApContact(addObj) {
    this.updateTabInfo(addObj, ContactRoleEnum.APContact);
    if (addObj) {
      this.enableSAveApcontact = true
      this.validateBillingTab()
    }
  }

  onchangePayment($event) {
    var indx = this.payTermsListList?.findIndex(x => x.value == $event?.value);
    if (indx >= 0) {
      this.appTransactionsForViewDto.paymentTermsCode = this.payTermsListList[indx].code;
      this.appTransactionsForViewDto.paymentTermsId = this.payTermsListList[indx].value;
    }
    this.enableSAveArcontact && this.enableSAveApcontact && this.appTransactionsForViewDto.paymentTermsId ? this.isContactsValid = true : this.isContactsValid = false;
    this.validateBillingTab()

  }
  updateArContact(addObj) {
    this.updateTabInfo(addObj, ContactRoleEnum.ARContact);
    if (addObj) {
      this.enableSAveArcontact = true
      this.validateBillingTab()
    }
  }

  validateBillingTab() {
    if (this.enableSAveArcontact && this.enableSAveApcontact && this.appTransactionsForViewDto.paymentTermsId) {
      this.isContactsValid = true;
      this.BillingInfoValid.emit(TransactionCartoccordionTabs.BillingInfo);

    } else {
      this.isContactsValid = false;
    }

  }

  saveDates() {
    let enteredDate = moment(this.appTransactionsForViewDto?.enteredDate).toDate();
    let startDate = moment(this.appTransactionsForViewDto?.startDate).toDate();
    let availableDate = moment(this.appTransactionsForViewDto?.availableDate).toDate();
    let completeDate = moment(this.appTransactionsForViewDto?.completeDate).toDate();

    this.appTransactionsForViewDto.enteredDate = moment.utc(moment(enteredDate).format('YYYY-MM-DD'));
    this.appTransactionsForViewDto.startDate = moment.utc(moment(startDate).format('YYYY-MM-DD'));
    this.appTransactionsForViewDto.availableDate = moment.utc(moment(availableDate).format('YYYY-MM-DD'));
    this.appTransactionsForViewDto.completeDate = moment.utc(moment(completeDate).format('YYYY-MM-DD'));
  }
  ngOnDestroy() {
    this.unsubscribeToAllSubscriptions();

  }
}